export enum UserValidationType {
  Internal = 0,
  Sso = 1,
}
